import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, Guard } from '@digibricks/core';
import { AudioFile, EssayAnswerValue, File } from '../../../../domain';
import { UpdateAnswerUseCase } from '../update-answer.usecase';
export var UPDATE_ESSAY_ANSWER_USE_CASE = 'UPDATE_ESSAY_ANSWER_USE_CASE';
export var UpdateEssayAnswerUseCase = /*#__PURE__*/function (_UpdateAnswerUseCase) {
  _inherits(UpdateEssayAnswerUseCase, _UpdateAnswerUseCase);

  var _super = _createSuper(UpdateEssayAnswerUseCase);

  function UpdateEssayAnswerUseCase(submissionRepository, saveFileStorageUseCase) {
    var _this;

    _classCallCheck(this, UpdateEssayAnswerUseCase);

    _this = _super.call(this, submissionRepository);
    _this.submissionRepository = submissionRepository;
    _this.saveFileStorageUseCase = saveFileStorageUseCase;
    return _this;
  }

  _createClass(UpdateEssayAnswerUseCase, [{
    key: "validate",
    value: function validate(useCaseInput) {
      var collection = [{
        argument: useCaseInput.input.value,
        argumentName: 'Answer Value'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(useCaseInput) {
        var _this2 = this;

        var validatedBasePropsOrError, resultOrError, input, answer, value, comment, addedFileStorageIds, text, files, audioFile, promise, updatedEssayAnswerOrError, _answer$value, _answer$value2, _answer$value3, updatedFiles, updatedAudioFile, _promise, updatedAnswerValueProps, updatedAnswerValueOrError;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                validatedBasePropsOrError = _get(_getPrototypeOf(UpdateEssayAnswerUseCase.prototype), "validateBaseInput", this).call(this, useCaseInput);

                if (!validatedBasePropsOrError.isFailure) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", Result.fail(validatedBasePropsOrError.error));

              case 3:
                resultOrError = this.validate(useCaseInput);

                if (!resultOrError.isFailure) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", Result.fail(resultOrError.error));

              case 6:
                input = useCaseInput.input, answer = useCaseInput.answer;
                value = input.value, comment = input.comment;
                addedFileStorageIds = value.addedFileStorageIds, text = value.text, files = value.files, audioFile = value.audioFile;

                if (!((addedFileStorageIds === null || addedFileStorageIds === void 0 ? void 0 : addedFileStorageIds.length) > 0)) {
                  _context3.next = 13;
                  break;
                }

                promise = addedFileStorageIds.map( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fileId) {
                    var saveFileUseCaseInput, savedFileOrError;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            saveFileUseCaseInput = {
                              id: fileId
                            };
                            _context.next = 3;
                            return _this2.saveFileStorageUseCase.execute(saveFileUseCaseInput);

                          case 3:
                            savedFileOrError = _context.sent;

                            if (!savedFileOrError.isFailure) {
                              _context.next = 6;
                              break;
                            }

                            return _context.abrupt("return", Result.fail(savedFileOrError.error));

                          case 6:
                            return _context.abrupt("return", savedFileOrError);

                          case 7:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());
                _context3.next = 13;
                return Promise.all(promise);

              case 13:
                _context3.next = 15;
                return this.submissionRepository.updateEssayAnswer(useCaseInput);

              case 15:
                updatedEssayAnswerOrError = _context3.sent;

                if (!updatedEssayAnswerOrError.isFailure) {
                  _context3.next = 18;
                  break;
                }

                return _context3.abrupt("return", Result.fail(updatedEssayAnswerOrError.error));

              case 18:
                if (!value) {
                  _context3.next = 31;
                  break;
                }

                if (!files) {
                  _context3.next = 24;
                  break;
                }

                _promise = files.map( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fileInput) {
                    var id, fileOrError;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            id = fileInput.id;
                            fileOrError = File.create(fileInput, id);
                            return _context2.abrupt("return", fileOrError.getValue());

                          case 3:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());
                _context3.next = 23;
                return Promise.all(_promise);

              case 23:
                updatedFiles = _context3.sent;

              case 24:
                if (audioFile) {
                  updatedAudioFile = AudioFile.create(audioFile, audioFile.id).getValue();
                }

                updatedAnswerValueProps = {
                  text: text ? text : answer === null || answer === void 0 ? void 0 : (_answer$value = answer.value) === null || _answer$value === void 0 ? void 0 : _answer$value.text,
                  files: updatedFiles ? updatedFiles : answer === null || answer === void 0 ? void 0 : (_answer$value2 = answer.value) === null || _answer$value2 === void 0 ? void 0 : _answer$value2.files,
                  audioFile: updatedAudioFile ? updatedAudioFile : answer === null || answer === void 0 ? void 0 : (_answer$value3 = answer.value) === null || _answer$value3 === void 0 ? void 0 : _answer$value3.audioFile
                };
                updatedAnswerValueOrError = EssayAnswerValue.create(updatedAnswerValueProps);

                if (!updatedAnswerValueOrError.isFailure) {
                  _context3.next = 29;
                  break;
                }

                return _context3.abrupt("return", Result.fail(updatedAnswerValueOrError.error));

              case 29:
                answer.updateValue(updatedAnswerValueOrError.getValue());

                if (comment) {
                  answer.updateComment(comment);
                }

              case 31:
                return _context3.abrupt("return", Result.ok({
                  answer: answer
                }));

              case 32:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return UpdateEssayAnswerUseCase;
}(UpdateAnswerUseCase);